import {
  ImageProps,
  Slide,
  chartOptionsToBase64Svg,
} from '@features/powerpoint';
import { contentSlideHeader } from '../../../../../utils';
import { buildChartOptions } from '@configurations/campaignAnalytics/visitsByHourOfDayChart';
import { CampaignAnalyticsSlideProps } from '../build-campaign-analytics-slides';
import { CHART_HEIGHT, CHART_WIDTH } from './charts';
import { Options } from 'highcharts';

export const visitsByTimeOfDayChartSlide = (
  props: CampaignAnalyticsSlideProps
): Slide => {
  const chartOptions: Options = buildChartOptions(
    props.campaignAnalyticsReport.visitsByHourOfDay.data
  );

  const visitsByTimeOfDayChart: string = chartOptionsToBase64Svg({
    chartOptions,
    height: CHART_HEIGHT,
    width: CHART_WIDTH,
  });

  const images: ImageProps[] = [
    {
      data: visitsByTimeOfDayChart,
      w: 11.85,
      h: 5.22,
      x: 0.74,
      y: 1.66,
    },
  ];

  return {
    slideMaster: props.slideMaster,
    texts: [contentSlideHeader('Visits By Time Of Day')],
    images,
  };
};
